import React, { useMemo, useRef, useState } from "react";
import mainAxios from "../../services/mainAxios";
import func, { isObjectEmpty } from "../../services/functions";
import { useTranslation } from "react-i18next";
import {
  AppContext,
  getStore,
  useAppContext,
  usePersistedState,
} from "../../AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faCashRegister,
  faChevronUp,
  faCircleCheck,
  faCompress,
  faCreditCard,
  faExpand,
  faMoneyBill,
  faMoneyBillAlt,
  faTimesCircle,
  faCartShopping,
  faCog,
  faUser,
  faCoins,
  faSliders,
  faArrowLeft,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import classnames from "classnames";
import Loader from "../Layout/Loader";
import { Link } from "react-router-dom";
import countries from "../../services/countries.json";
import invoiceActions from "../../services/invoiceActions.json";
import invoiceStatuses from "../../services/invoiceStatuses.json";
import { toast } from "react-toastify";
import PosDetails from "../../components/MyPos/components/PosDetails";
import PopOver from "../global/PopOver";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useEffect } from "react";
import OpenTcrData from "../CashRegister/OpenTcrData";
import FinalizeInvoice from "./components/FinalizeInvoice";
import { Dialog } from 'primereact/dialog';
import { Tooltip } from "primereact/tooltip";
import Swal from "sweetalert2";

const bigDecimal = require("js-big-decimal");
const { round } = func;

const CreatePosTransaction = (props) => {
  const {
    user: [user],
    selectedCompany: [selectedCompany],
    company: [fullCompany],
    sideBarExpanded: [, setSideBarExpanded]
  } = useAppContext();
  const { t } = useTranslation("translations");
  const firstUpdate = React.useRef(true);
  const location = useLocation();
  const [isFullScreen, setIsFullScreen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [printInvoice, setPrintInvoice] = React.useState(
    location?.state?.printInvoice || false
  );
  const [searchValue, setSearchValue] = React.useState("");
  const [tcrDataOperations, setTcrDataOperations] = useState([])
  const [zeroPriceItems, setZeroPriceItems] = useState({})
  const [reloadCashDeposit, setReloadCashDeposit] = useState(false)
  const [rateBoaDate, setRateBoaDate] = useState(null)
  const [isUsingBoaRate, setIsUsingBoaRate] = useState(false)
  const [boaExchangeRate, setBoaExchangeRate] = useState(null)
  const [persistedData, setPersistedData] = usePersistedState({ rate: "1", currency: "ALL", businessUnitCode: null, tcrCode: null, profileId: "P1" }, "persistedData");
  const [persistedStatePos, setPersistedStatePos] = usePersistedState(null, "persistedStatePos");
  // const [visibleCashRegister, setVisibleCashRegister] = useState(false)
  const [cashRegisterTcrType,setCashRegisterTcrType]=useState({ actionType:"",isOpen:false })
  const [finalizeDialogVisible, setFinalizeDialogVisible] = useState(false);
  const [finalizeDialogState, setFinalizeDialogState] = useState(null);
  const [profileDialogVisible, setProfileDialogVisible] = useState(false);
  const [cartStep, setCartStep] = useState("review");
  const [customerDialogVisible, setCustomerDialogVisible] = useState(false);
  const [mobileCartOpen, setMobileCartOpen] = useState(false);

  // Auto-close mobile cart drawer when resizing to/from mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setMobileCartOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    // Also close on initial load if mobile
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const company = user.companiesRights.find(
    (company) => company.id === parseInt(selectedCompany)
  );

  const fullBranchMap = useMemo(() => {
    const map = {};
    if (fullCompany?.branches) {
      for (const fb of fullCompany.branches) {
        map[fb.businUnitCode] = fb;
      }
    }
    return map;
  }, [fullCompany?.branches]);

  const branchesOptions = useMemo(() => {
    return company.branches.map((branch) => {
      const existCis = fullBranchMap[branch.businUnitCode]?.existCis ?? true;
      return {
        ...branch,
        label: branch.businUnitCode + " - " + branch.sellerAddress,
        value: branch.businUnitCode + " - " + branch.sellerAddress,
        existCis,
        inactive: !existCis
      }
    })
  }, [company?.branches, fullBranchMap])


  const currenciesPos = [
    { label: "Lek", value: "ALL" },
    { label: "US Dollar", value: "USD" },
    { label: "Euro", value: "EUR" },
  ];

  const currencySelectStyle = {
    control: (base) => ({
      ...base,
      minHeight: '32px',
      height: '32px',
      border: 'none',
      boxShadow: 'none',
      background: 'transparent',
      cursor: 'pointer',
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '0 4px',
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '0.8rem',
      fontWeight: 600,
      color: '#111827',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '32px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '4px',
      color: '#9ca3af',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    menu: (base) => ({
      ...base,
      width: '140px',
      fontSize: '0.8rem',
      borderRadius: '8px',
      boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      zIndex: 9999,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      fontSize: '0.8rem',
      padding: '0.5rem 0.75rem',
      backgroundColor: state.isSelected
        ? 'rgba(0, 117, 103, 0.08)'
        : state.isFocused
          ? '#f8f9fc'
          : 'transparent',
      color: state.isSelected ? '#007567' : '#374151',
      cursor: 'pointer',
    }),
  };

  const defaultPosState = {
    parties: {
      buyer: {
        tin: null,
        name: "",
        address: "",
        country: "Albania",
        town: "",
        buyerIDType: "NUIS",
      },
      seller: {
        tin: "",
        address: "",
        country: "",
        town: "",
        name: "",
        sellerIDType: "NUIS",
      },
    },
    type: process.env.REACT_APP_EINVOICE_CODE,
    correctiveInvType: "",
    profileId: persistedData?.profileId ?? "P1",
    number: "",
    issueDate: new Date(),
    dueDate: new Date(),
    invoiceStartDate: "",
    invoiceEndDate: "",
    discount: {
      type: t(["invoice.value"]),
      value: "",
      vat: company.issuerInVat ? "20" : "0",
      vatLabel: null,
    },
    bankAccount: null,
    attachments: [],
    currency: persistedData?.currency ?? "ALL",
    rate: persistedData.rate ?? "1",
    // currency:"1",seperated usePeristed state
    contract: "",
    info: "",
    invoiceTotalWithoutVat: "0",
    invoiceTotalDiscount: "0",
    invoiceDiscountedTotalWithoutVat: "0",
    invoiceTotalVat: "0",
    invoiceTotalWithVat: "0",
    tcrCode: "",
    businessUnitCode: "",
    opCode: user?.userCompanyOperator?.find(
      (uco) => parseInt(uco.company) === parseInt(selectedCompany)
    )?.operator,
    paymentMethodType: "cash",
    items: [],
    einvoice: false,
    paymentMeans: "",
    internalId: "",
    typeOfSelfInvoice: "",
    selfInvoice: false,
    reverseCharge: false,
    iic_ref: "",
    refInvIIC: "",
    refInvIssueDateTime: "",
    hasTransport: false,
    transporter: "",
    vehiclePlate: "",
    destinationAddress: "",
    correctionOfSelfInvoice: false,
    subSequenceDelivType: "",
    source: "MP",
    param1: "",
    param2: "",
    // param3:"",
    // param4:"",
    paymentNote: "",
    invoiceFees: [],
    referenceData: {
      buyerReference: null,
      projectReference: null,
      contractReference:null,
      purchaseOrderReference:null,
      salesOrderReference:null,
      receiptReference:null,
      despatchNoteReference:null,
      requestForBidReference:null,
      schemaIdentifier:null
    }
  };

  const [posState, setPosState] = React.useState(defaultPosState);
  const [code, setCode] = useState("");
  const codeRef = useRef(null);
  const categoryTabsRef = useRef(null);
  const cartPanelRef = useRef(null);
  const dragRef = useRef({
    isDragging: false, startY: 0, startTranslateY: 0,
    currentTranslateY: 0, collapsedTranslateY: 0,
    lastY: 0, lastTime: 0, velocity: 0,
  });

  // Always default to general customer on new invoice creation
  useEffect(() => {
    setPosState((prev) => ({
      ...prev,
      parties: {
        ...prev.parties,
        buyer: {
          tin: "99999",
          name: t("pos.generalCustomer"),
          address: " ",
          country: "Albania",
          town: " ",
          buyerIDType: "ID",
        },
      },
    }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Drag-to-scroll for category tabs
  const handleCategoryMouseDown = (e) => {
    const el = categoryTabsRef.current;
    if (!el) return;
    el.dataset.dragging = "true";
    el.dataset.startX = e.pageX;
    el.dataset.scrollLeft = el.scrollLeft;
  };
  const handleCategoryMouseMove = (e) => {
    const el = categoryTabsRef.current;
    if (!el || el.dataset.dragging !== "true") return;
    e.preventDefault();
    const dx = e.pageX - parseFloat(el.dataset.startX);
    el.scrollLeft = parseFloat(el.dataset.scrollLeft) - dx;
  };
  const handleCategoryMouseUp = () => {
    const el = categoryTabsRef.current;
    if (el) el.dataset.dragging = "false";
  };

  // Touch drag for mobile bottom drawer
  const handleDrawerTouchStart = (e) => {
    const panel = cartPanelRef.current;
    if (!panel) return;
    const touch = e.touches[0];
    const collapsedY = panel.offsetHeight - 64;
    dragRef.current = {
      isDragging: true,
      startY: touch.clientY,
      startTranslateY: mobileCartOpen ? 0 : collapsedY,
      currentTranslateY: mobileCartOpen ? 0 : collapsedY,
      collapsedTranslateY: collapsedY,
      lastY: touch.clientY,
      lastTime: Date.now(),
      velocity: 0,
    };
    panel.style.transition = 'none';
  };

  const handleDrawerTouchMove = (e) => {
    if (!dragRef.current.isDragging) return;
    const panel = cartPanelRef.current;
    if (!panel) return;
    const touch = e.touches[0];
    const deltaY = touch.clientY - dragRef.current.startY;
    let newY = dragRef.current.startTranslateY + deltaY;
    newY = Math.max(0, Math.min(newY, dragRef.current.collapsedTranslateY));
    dragRef.current.currentTranslateY = newY;
    const now = Date.now();
    const dt = now - dragRef.current.lastTime;
    if (dt > 0) {
      dragRef.current.velocity = (touch.clientY - dragRef.current.lastY) / dt;
    }
    dragRef.current.lastY = touch.clientY;
    dragRef.current.lastTime = now;
    panel.style.transform = `translateY(${newY}px)`;
  };

  const handleDrawerTouchEnd = () => {
    if (!dragRef.current.isDragging) return;
    const panel = cartPanelRef.current;
    if (!panel) return;
    dragRef.current.isDragging = false;
    const { currentTranslateY, collapsedTranslateY, velocity } = dragRef.current;
    const threshold = collapsedTranslateY * 0.4;
    let shouldOpen;
    if (Math.abs(velocity) > 0.3) {
      shouldOpen = velocity < 0;
    } else {
      shouldOpen = currentTranslateY < threshold;
    }
    panel.style.transition = '';
    panel.style.transform = shouldOpen ? 'translateY(0)' : 'translateY(calc(100% - 64px))';
    setMobileCartOpen(shouldOpen);
    let cleaned = false;
    const cleanup = () => {
      if (cleaned) return;
      cleaned = true;
      if (panel) panel.style.transform = '';
    };
    panel.addEventListener('transitionend', cleanup, { once: true });
    setTimeout(cleanup, 500);
  };

  const defaultCashRegisterData = {
    tcr: posState.tcrCode,
    initialTotal: 0,
    initialAction: 0,
    withdrawTotal: 0,
    withdrawAction: 0,
    depositTotal: 0,
    depositAction: 0,
  };
  const [cashRegisterData, setCashRegisterData] = useState(
    defaultCashRegisterData
  );

  const tcrList = useMemo(() => {
    let filteredBranch = company.branches.find(
      (branch) =>
        // branch.businUnitCode == persistedData?.businessUnitCode ||
        branch.businUnitCode == posState.businessUnitCode
    );
  
    let tcrTypes = filteredBranch?.tcrTypes
      .filter((tcrType) => tcrType?.allowInvoice)
      .sort((a, b) => new Date(b.recordDate) - new Date(a.recordDate)) ?? [];
  
    let tcrList = tcrTypes.map((tcr) => {
      let sellerName = filteredBranch.sellerName;
      return {
        label: tcr.tcrCode + "-" + sellerName,
        value: tcr.tcrCode,
        inactive: tcr.status < 100
      };
    });
  
    return tcrList.length > 0
      ? [{ label: "Select", value: "" }].concat(tcrList)
      : tcrList;
  }, [selectedCompany, posState?.businessUnitCode]);
  

  const typeOfPaymentMeansNonCash = [
    { label: t("invoice.transfer"), value: "31",btnLabel: t("invoice.transferBtn") },
    { label: t("invoice.account"), value: "42", btnLabel: t("invoice.accountBtn") },
    { label: t("invoice.other"), value: "ZZZ" , btnLabel: t("invoice.otherBtn") },
  ];

  const typeOfPaymentMeansCash = [
    { label: "BANKNOTE", value: "10" },
    { label: "BANK CARD", value: "48" },
  ];

  const [state, setState] = React.useState(
    location?.state?.state || {
      categories: null,
      activeCategory: persistedStatePos?.activeCategory ?? null,
      allItems: null,
      filteredItems: null,
    }
  );


  useEffect(() => {
    let branch =
      company.branches.find((branch) => branch.default) ||
      company.branches[0];
  
    let businessUnitCode = branch?.businUnitCode ?? "";
    let tcrCode = branch.tcrTypes
      .filter(tcrType => tcrType.businUnitCode === businessUnitCode && tcrType?.allowInvoice &&  !(tcrType?.status < 100))
      .sort((a, b) => new Date(b.recordDate) - new Date(a.recordDate))[0]?.tcrCode || "";
  

    /*Remove persidted logic for Branches/TCR*/
    
    // let persistedBranch = branchesOptions?.find(
    //   (branch) => branch?.businUnitCode == persistedData?.businessUnitCode
    // );
  
    // if (persistedData?.tcrCode && tcrList.some((tcr) => tcr?.value == persistedData?.tcrCode)) {
    //   tcrCode = persistedData.tcrCode;
    // }
  
    // if (persistedBranch) {
    //   businessUnitCode = persistedData.businessUnitCode;
    //   branch = persistedBranch;
    // }
  
    const seller = {
      tin: company.nuis,
      address: branch.sellerAddress,
      country: countries.find((country) => country.label === branch.sellerCountry)?.value || "Albania",
      town: branch.sellerTown,
      name: company.name,
      sellerIDType: "NUIS",
    };
  
    setPosState((invoiceState) => ({
      ...invoiceState,
      parties: {
        ...invoiceState.parties,
        seller,
      },
      businessUnitCode,
      tcrCode,
    }));
  
    let allItems = location?.state?.state?.allItems;
    if (!allItems || allItems?.length == 0) {
      mainAxios
        .post("apiEndpoint/search", {
          object: "GetCompanyItems",
          value: "",
        })
        .then((res) => {
          if (res?.data?.status === true) {
            const items = res.data.content;
            const categories = items.reduce(
              (obj, item) => ({
                ...obj,
                [item.category.name]: obj[item.category.name]
                  ? obj[item.category.name] + 1
                  : 1,
              }),
              {}
            );
  
            setState((state) => ({
              ...state,
              allItems: items,
              filteredItems: items,
              categories,
            }));
          }
        });
    }
  }, [selectedCompany]);


  useEffect(() => {
    mainAxios
      .post("/apiEndpoint/reportOnCashDeposit", {
        object: "CashDepositRequest",
        params: {
          sendDateTime: moment().format("YYYY-MM-DD"),
          issuerNUIS: company.nuis,
        },
      })
      .then((res) => {
        setTcrDataOperations(res.data.content);
      });
  }, [reloadCashDeposit, company.nuis]);
  

  useEffect(() => {
    if (posState) {
      const {
        items,
        invoiceTotalWithoutVat,
        invoiceTotalVat,
        invoiceTotalWithVat,
        invoiceTotalDiscount,
        invoiceDiscountedTotalWithoutVat,
      } = func.calculateInvoiceData(posState);
  
      setPosState((invoice) => ({
        ...invoice,
        invoiceTotalWithoutVat,
        invoiceTotalVat,
        invoiceTotalWithVat,
        invoiceTotalDiscount,
        invoiceDiscountedTotalWithoutVat,
        items,
      }));
    }
  }, [
    ...posState.items.map((item) => {
      return `${item.quantity},${item.discountValue},${item.discountType},${item.priceWithVat},${item.priceWithoutVat}`;
    }),
    posState.items.length,
    posState.discount,
  ]);
  
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
  
    let filteredItems = [];
    if (searchValue.length === 0) {
      if (state.activeCategory == null) {
        filteredItems = state.allItems;
      } else if (state.activeCategory) {
        filteredItems = state.allItems.filter(
          (item) => item.category.name === state.activeCategory
        );
      }
    } else {
      filteredItems = state.allItems.filter((item) => {
        let itemName = item.name.toLowerCase();
        let searchVal = searchValue.toLowerCase();
        return (
          searchVal !== "" &&
          itemName.includes(searchVal) &&
          (item.category.name === state.activeCategory ||
            state.activeCategory === null)
        );
      });
    }
  
    setState((state) => ({
      ...state,
      filteredItems,
    }));
  }, [searchValue, state.activeCategory]);
  
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
  
    if (code?.length < 4) {
      return;
    }
  
    const indicator = setTimeout(() => {
      state.allItems.forEach((item) => {
        if (item.code == code) {
          addRemoveItem(item);
          setCode("");
        }
      });
    }, 400);
  
    return () => {
      clearTimeout(indicator);
    };
  }, [code]);

  React.useEffect(() => {
    if (tcrDataOperations.length == 0) return;
    const result = Object.values(
      tcrDataOperations
        .filter((o) => o.tcr == posState.tcrCode)
        .reduce((a, { tcr, ...props }) => {
          if (!a[tcr]) a[tcr] = Object.assign({}, { tcr, operations: [props] });
          else a[tcr].operations.push(props);
          return a;
        }, {})
    );
  
    if (result.length == 0) {
      setCashRegisterData(defaultCashRegisterData);
    }
  
    let initial = result[0]?.operations?.find(
      (el) => el.operation == "INITIAL"
    );
    let withdraw = result[0]?.operations?.find(
      (el) => el.operation == "WITHDRAW"
    );
    let deposit = result[0]?.operations?.find(
      (el) => el.operation == "DEPOSIT"
    );
  
    setCashRegisterData({
      tcr: posState.tcrCode,
      initialTotal: initial?.total ?? 0,
      initialAction: initial?.actions ?? 0,
      depositTotal: deposit?.total ?? 0,
      depositAction: deposit?.actions ?? 0,
      withdrawTotal: withdraw?.total ?? 0,
      withdrawAction: withdraw?.actions ?? 0,
    });
  }, [posState.tcrCode, tcrDataOperations]);
  
  useEffect(() => {
    if (posState?.items.length > 0) {
      let zeroPrices = {};
      let newItems = posState.items.map((item) => {
        let fullItem = state.allItems.find((i) => i.code == item.code);
        const { priceWvat, priceWovat } = priceByCurrency(fullItem);
        if (priceWovat == 0) zeroPrices[item.code] = true;
        return {
          ...item,
          priceWithVat: priceWvat,
          priceWithoutVat: priceWovat,
          unitPrice: priceWovat,
        };
      });
      setZeroPriceItems(zeroPrices);
      setPosState((state) => ({
        ...state,
        items: newItems,
      }));
    }
  }, [persistedData.currency]);
  

  const convertedValue = posState.items.reduce((sum, item) => {
    return bigDecimal.add(
      bigDecimal.add(
        round(bigDecimal.multiply(item.totalWithoutVat, persistedData.rate), 2),
        round(
          bigDecimal.multiply(
            bigDecimal.multiply(item.totalWithoutVat, persistedData.rate),
            bigDecimal.divide(parseFloat(item.vatCategory), 100)
          ),
          2
        )
      ),
      sum
    );
  }, 0);


    const hasNoCustomer=useMemo(()=>{
      const {country,id,...buyerWoCountry} = posState.parties.buyer
      return Object.values(buyerWoCountry).every(v => v === null || v === "")
    },[posState?.parties?.buyer])

  const approveInvoice = ({ invoiceState }) => {
    setLoading(true);
    mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          action: invoiceActions[2],
          status: invoiceStatuses[2],
          ...func.parseCustomInvoiceRequest(invoiceState),
          // ...restPersistedData
        },
        nuis: company.nuis,
      }, { showErrorToast: false })
      .then(async (res) => {
        const savedInvoice = res?.data?.content?.[0];
        if (res?.data?.status === true) {
          setFinalizeDialogVisible(false);
          toast.success(t(["toast.successApprovalPOS"]), {
            containerId: "all_toast",
          });
          props.history.push({
            pathname: "/pos-transactions/edit/" + savedInvoice.id,
            state: { state: { ...state }, printInvoice },
          });
        } else if (savedInvoice?.erpId) {
          // Fiscalization failed but a CustomInvoice was persisted. The backend
          // returns a fiscalization queue record here (its id is NOT the CustomInvoice id),
          // so resolve the real id via erpId == CustomInvoice.internalId before navigating.
          setFinalizeDialogVisible(false);
          const errorMsg = res?.data?.error?.errorDescription || res?.data?.message;
          if (errorMsg) {
            toast.error(errorMsg, { containerId: "all_toast" });
          }
          try {
            const lookup = await mainAxios.post("apiEndpoint/search", {
              object: "GetCustomInvoiceV",
              params: { internalId: savedInvoice.erpId },
              pagination: { pageSize: 1, pageNumber: 1 },
              sortCriteria: [{ field: "recordDate", direction: "DESC" }],
            }, { showErrorToast: false });
            const realId = lookup?.data?.content?.[0]?.id;
            if (realId) {
              props.history.push({
                pathname: "/pos-transactions/edit/" + realId,
                state: { state: { ...state }, printInvoice },
              });
              return;
            }
          } catch (e) { /* fall through to inline message */ }
        } else {
          const error = res?.data?.error;
          const details = [];
          if (error?.errorCode) details.push(`<b>Code:</b> ${error.errorCode}`);
          if (error?.errorDescription) details.push(`<b>Description:</b> ${error.errorDescription}`);
          if (res?.data?.faultReason) details.push(`<b>Reason:</b> ${res.data.faultReason}`);
          Swal.fire({
            icon: "error",
            title: res?.data?.message || "Error",
            html: details.length ? details.join("<br/>") : undefined,
            confirmButtonColor: "#007567",
            confirmButtonText: t("OK"),
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };


  const draftInvoice = async ({ invoiceState }) => {

    setLoading(true);

    mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          action: invoiceActions[0],
          status: invoiceStatuses[0],
          ...func.parseCustomInvoiceRequest(invoiceState),
          // ...restPersistedData
        },
        nuis: company.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(t(["toast.draftSaved"]), {
            containerId: "all_toast",
          });
          props.history.push({
            pathname: "/pos-transactions/edit/" + res.data.content[0].id,
            state: { state: { ...state }, printInvoice },
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);

      });
  };

  const handleCategoryChange = (category) => {
    setPersistedStatePos({
      ...persistedStatePos,
      activeCategory: category ?? null,
    });
    setState((state) => ({
      ...state,
      activeCategory: category ?? null,
    }));
  };

  const handleDiscountChange = (key, value, index) => {
  
    const {
      unitPrice,
      discountType: dt,
      discountValue: dv,
      vatCategory: vat,
    } = posState.items[index];
 
    const discountType = key === "discountType" ? value : dt;
    const discountValue = key === "discountValue" ? value : dv;
    let discount;
    let count = func.countDecimals(discountValue);
    if (discountType === "Percentage") {
      if (count > 6) {
        return;
      }
      discount = bigDecimal.multiply(
        unitPrice,
        bigDecimal.divide(discountValue, 100)
      );
    } else {
      if (count > 2) {
        return;
      }
      discount = discountValue;
    }

    const priceWithoutVat = bigDecimal.subtract(unitPrice, discount);

    const priceWithVat =
      vat == 0
        ? unitPrice
        : bigDecimal.multiply(
          unitPrice,
          bigDecimal.add(1, bigDecimal.divide(vat, 100))
        );
    
    setPosState((invoiceState) => ({
      ...invoiceState,
      items: [
        ...invoiceState.items.slice(0, index),
        {
          ...invoiceState.items[index],
          [key]: value,
          priceWithoutVat: parseFloat(priceWithoutVat).toFixed(2),
          priceWithVat: parseFloat(priceWithVat).toFixed(2),
        },
        ...invoiceState.items.slice(index + 1),
      ],
    }));
  };

  const handlePriceWithVatChange = (e, item, index) => {
    let value = e.target.value;

    if (value === "") {
      const updatedItems = posState.items.map((oldItem, oldIndex) =>
        oldIndex !== index
          ? oldItem
          : { ...item, priceWithVat: "", priceWithoutVat: "0", unitPrice: "0" }
      );
      setPosState((posState) => ({ ...posState, items: updatedItems }));
      return;
    }

    if (value.split(".")[1]) {
      value = value.split(".");
      value = value[0] + "." + value[1].slice(0, 2);
    }
    if (value.includes("-")) {
      value = value.split("-")[1] || "";
    }

    const {
      vatCategory: vat,
      discountValue,
      discountType,
    } = posState.items[index];
    const priceWithVat = new bigDecimal(value).getValue();
    const priceWithoutVat =
      vat == 0
        ? priceWithVat
        : bigDecimal.divide(
          priceWithVat,
          bigDecimal.add(1, bigDecimal.divide(vat, 100))
        );
    let discount;

    if (discountType === "Percentage") {
      discount = bigDecimal.multiply(
        bigDecimal.divide(
          priceWithoutVat,
          bigDecimal.subtract(1, bigDecimal.divide(discountValue, 100))
        ),
        bigDecimal.divide(discountValue, 100)
      );
    } else {
      discount = discountValue;
    }

    const unitPrice = bigDecimal.add(priceWithoutVat, discount);

    const updatedItems = posState.items.map((oldItem, oldIndex) =>
      oldIndex !== index
        ? oldItem
        : {
          ...item,
          unitPrice: unitPrice,
          priceWithVat,
          priceWithoutVat:priceWithoutVat,
        }
    );

    setPosState((posState) => ({
      ...posState,
      items: updatedItems,
    }));
  };

  const addRemoveItem = (item, quantity = "1", fixedQuantity = false) => {
    let isNumOrEmptyStr = /^$|^[+-]?\d+(\.\d+)?$/.test(quantity);
    if (
      !isNumOrEmptyStr ||
      (fixedQuantity && parseFloat(quantity) < 0) ||
      func.countDecimals(quantity) > 3
    ) {
      return;
    }
    let itemIndex = posState.items.findIndex(
      (currItem) => item.code == currItem.code
    );
    let newItem;
    if (itemIndex >= 0) {
      let item = posState.items[itemIndex];
      if (
        (!fixedQuantity &&
          (quantity == "1" ||
            (quantity == -"1" && parseFloat(item.quantity) > 1))) ||
        fixedQuantity
      ) {
        newItem = {
          ...item,
          quantity: fixedQuantity
            ? quantity
            : bigDecimal.add(item.quantity, quantity.toString()),
        };
        setPosState((posState) => ({
          ...posState,
          items: [
            ...posState.items.slice(0, itemIndex),
            newItem,
            ...posState.items.slice(itemIndex + 1),
          ],
        }));
      } else if (
        (quantity == -"1" && item.quantity == "1") ||
        quantity == "0"
      ) {
        let items = [...posState.items];
        items.splice(itemIndex, 1);
        setPosState((posState) => ({
          ...posState,
          items,
        }));
      }
    } else {
      const { priceWvat, priceWovat } = priceByCurrency(item);
      newItem = {
        code: item.code,
        description: item.vatReason,
        discountType: "Percentage",
        discountValue: "",
        investment: item.investment,
        name: item.name,
        priceWithVat: priceWvat,
        priceWithoutVat: priceWovat,
        quantity: "1",
        totalWithVat: priceWvat,
        totalWithoutVat: priceWovat,
        unitOfMeasureId: item?.unitOfMeasureId,
        unitPrice: priceWovat,
        vatCategory: item.vatCategory,
        vatLabel: item?.vatReason == "" ? null : item?.vatReason,
      };
      setPosState((posState) => ({
        ...posState,
        items: [...posState.items, newItem],
      }));

      if (newItem.priceWithoutVat == 0) {
        setZeroPriceItems((state) => ({
          ...state,
          [newItem.code]: true,
        }));
      }
    }
  };

  const handleChange = (key, value) => {
    setPosState((posState) => ({
      ...posState,
      [key]: value,
    }));
  };
  
  const handlePaymentMean = async (value, paymentMethodType) => {
    const { issueDate, tcrCode, businessUnitCode } = posState
    const issDate = moment(issueDate).endOf('day')
    const today = moment().endOf('day')

    if (posState?.parties?.buyer?.buyerIDType !== "NUIS" && paymentMethodType === "cash" &&((posState.currency =="ALL" && (parseFloat(posState?.invoiceTotalWithVat) > 500000)) || (posState.currency !== "ALL" && parseFloat(posState?.invoiceTotalWithVat) > 5000) )) {
      const confirmation = await Swal.fire({
        text: t("toast.amountExceedesAlert"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#007567",
        confirmButtonText: t("OK"),
        cancelButtonText: t("invoice.backToInvoice"),
      });

      if (!confirmation.isConfirmed) {
        return;
      }
    }

    const { buyerIDType, tin,town } = posState?.parties?.buyer

    if(buyerIDType && (tin == null || tin?.length==0)){
      toast.error(t("toast.buyerTinRequired"), {
        containerId: "all_toast",
      });
      return;
    }
    if((town==null || town?.length==0) && !hasNoCustomer){
      toast.error(t("pos.cityRequired"), {
        containerId: "all_toast",
      });
      return;
    }

    if (tcrCode?.length === 0) {
      toast.error(t(["toast.tcrCode"]), {
        containerId: "all_toast",
      });
      return;
    }
    if (businessUnitCode?.length === 0) {
      toast.error(t(["toast.bussinUnitCode"]), {
        containerId: "all_toast",
      });
      return;
    }

    if (issDate > today) {
      toast.error(t(["toast.issueDateErr"]), {
        containerId: "all_toast",
      });
      return;
    }
    if (posState.items.length == 0) {
      toast.error("You need to chose at least one item.", {
        containerId: "all_toast",
      });
      return;
    }
    if (posState?.currency !== "ALL" && (posState?.rate === null || posState?.rate === "" || posState?.rate=="0") )  {
      toast.error("Exchange Rate is Required", {
        containerId: "all_toast",
      });
      return;
    }
    // if (!posState?.parties.buyer?.tin) {
    //   toast.error("Please complete customer information", {
    //     containerId: "all_toast",
    //   });
    //   return;
    // }
    if (
      posState?.parties?.buyer?.buyerIDType === "NUIS" &&
      posState?.paymentMethodType === "cash" &&
      posState?.invoiceTotalWithVat > 150000
    ) {
      toast.error(t(["toast.errorPos"]), {
        containerId: "all_toast",
      });
      return;
    }

    let itemPriceValidation = true;
    posState.items.forEach((item) => {
      if (item.priceWithVat == 0) {
        itemPriceValidation = false;
        return;
      }
    });
    if (!itemPriceValidation) {
      toast.error("Item price must not be 0", {
        containerId: "all_toast",
      });
      return;
    }

    setFinalizeDialogState({ paymentMeans: value, paymentMethodType });
    setFinalizeDialogVisible(true);
    handleChange("paymentMeans", value);
  };


  const getExchangeRates = () => {
    const selectedCurrencyCode = persistedData?.currency;
    mainAxios
      .post(`api/exchange-rates/getByCode?code=${selectedCurrencyCode}`, {})
      .then((res) => {
        const data = res?.data;
        if (data) {
          const [year, month, day, hour, minute, second] = data.modifiedDate;
          const date = moment({
            month: month - 1, year, day, hour, minute, second
          }).format("DD/MM/YYYY HH:mm:ss");
          setRateBoaDate(date);
          setBoaExchangeRate(data?.value);
          setIsUsingBoaRate(true);
          setPosState((state) => ({ ...state, rate: data?.value }));
          setPersistedData({ ...persistedData, rate: data?.value });
        }
      })
      .catch((error) => {
        console.error('Error fetching exchange rate:', error);
      });
  };

  const isRateBoaDateDifferent = () => {
    const today = moment().format("DD/MM/YYYY H:mm:ss");
    return rateBoaDate && rateBoaDate != today;
  };

  const calculateRateDifference = () => {
    if (!boaExchangeRate || !posState?.rate) return null;
    const customRate = parseFloat(posState.rate);
    const boaRate = parseFloat(boaExchangeRate);
    if (isNaN(customRate) || isNaN(boaRate) || boaRate === 0) return null;
    const percentageDiff = ((customRate - boaRate) / boaRate) * 100;
    const isHigher = percentageDiff > 0;
    const absDiff = Math.abs(percentageDiff).toFixed(2);
    return {
      percentage: absDiff,
      isHigher,
      direction: isHigher ? 'exchangeMore' : 'exchangeLess'
    };
  };

  const priceByCurrency = (item) => {
    let priceWvat = item?.priceWvatAll?.toString() ?? "0";
    let priceWovat = item?.priceWovatAll?.toString() ?? "0";
    let currency = "L";
    if (persistedData.currency == "EUR") {
      priceWvat = item?.priceWvatEur?.toString() ?? "0";
      priceWovat = item?.priceWovatEur?.toString() ?? "0";
      currency = "€";
    } else if (persistedData.currency == "USD") {
      priceWvat = item?.priceWvatUsd?.toString() ?? "0";
      priceWovat = item?.priceWovatUsd?.toString() ?? "0";
      currency = "$";
    }
    return { priceWvat, priceWovat, currency };
  };

  const { allItems, filteredItems, activeCategory, categories } = state;
  const { paymentMethodType, paymentMeans } = posState;

  return (
    <div className={classnames("pos-terminal", { "pos-terminal--fullscreen": isFullScreen })}>
      {/* Dialogs are rendered below, outside the main layout flow */}

      {/* Profile & Invoice Settings Dialog */}
      <Dialog
        header={t("invoice.profileId") + " / " + t("home.branches") + " / " + t("home.tcr")}
        visible={profileDialogVisible}
        onHide={() => setProfileDialogVisible(false)}
        style={{ width: '55vw', maxWidth: '900px' }}
        breakpoints={{ '1200px': '70vw', '960px': '85vw', '641px': '95vw' }}
        modal
        baseZIndex={1300}
        className="pos-section-dialog"
      >
        {profileDialogVisible && (
          <PosDetails
            section="profile"
            posState={posState}
            setPosState={setPosState}
            persistedData={persistedData}
            setPersistedData={setPersistedData}
            branchesOptions={branchesOptions}
            tcrList={tcrList}
            location={location}
            hasNoCustomer={hasNoCustomer}
          />
        )}
      </Dialog>

      {/* Customer Dialog */}
      <Dialog
        header={t("navbar.customers") || "Customer"}
        visible={customerDialogVisible}
        onHide={() => setCustomerDialogVisible(false)}
        style={{ width: '55vw', maxWidth: '920px' }}
        breakpoints={{ '1200px': '70vw', '960px': '85vw', '641px': '95vw' }}
        modal
        baseZIndex={1300}
        className="pos-section-dialog"
      >
        {customerDialogVisible && (
          <PosDetails
            section="customer"
            posState={posState}
            setPosState={setPosState}
            persistedData={persistedData}
            setPersistedData={setPersistedData}
            branchesOptions={branchesOptions}
            tcrList={tcrList}
            location={location}
            hasNoCustomer={hasNoCustomer}
          />
        )}
      </Dialog>

      {/* Cash Register Dialog */}
      <Dialog header={cashRegisterTcrType?.actionType ? t(`cashRegister.${cashRegisterTcrType.actionType.toLowerCase()}`) : ''} visible={cashRegisterTcrType?.isOpen} style={{ width: '45vw' }} breakpoints={{ '960px': '75vw', '641px': '95vw' }} onHide={() => setCashRegisterTcrType({ isOpen: false })}>
        {cashRegisterTcrType?.isOpen && <OpenTcrData
          onClose={() => { setCashRegisterTcrType(null) }}
          onChange={() => { setReloadCashDeposit((state) => !state) }}
          data={{
            ...cashRegisterData,
            tcr: posState?.tcrCode,
            actionType: cashRegisterTcrType?.actionType,
            businUnitCode: posState?.businessUnitCode,
          }}
        />}
      </Dialog>

      {/* ── Main Two-Panel Layout ── */}
      <div className="pos-main">
        {/* ── LEFT: Items Panel ── */}
        <div className="pos-items-panel">
          {/* Command Bar — 2 Rows */}
          <div className="pos-command-bar">
            {/* Row 1: Print, E-Invoice, Customer, Profile, Currency, Fullscreen */}
            <div className="pos-command-bar__row1">
              <div className="custom-control custom-checkbox pos-command-bar__check" onClick={(e) => e.stopPropagation()}>
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="printInvoiceBar"
                  checked={printInvoice}
                  onChange={(e) => setPrintInvoice(e.target.checked)}
                />
                <label htmlFor="printInvoiceBar" className="custom-control-label">{t("pos.print")}</label>
              </div>
              <div className="custom-control custom-checkbox pos-command-bar__check" onClick={(e) => e.stopPropagation()}>
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="eInvoiceBar"
                  checked={posState?.einvoice || false}
                  onChange={(e) => handleChange("einvoice", e.target.checked)}
                />
                <label htmlFor="eInvoiceBar" className="custom-control-label">{t("pos.eInvoice")}</label>
              </div>
              {!posState?.einvoice && (
                <div className="custom-control custom-checkbox pos-command-bar__check" onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="noCustomerBar"
                    checked={hasNoCustomer}
                    onChange={() => {
                      setPosState((state) => ({
                        ...state,
                        parties: {
                          ...state.parties,
                          buyer: hasNoCustomer
                            ? { tin: "99999", name: t("pos.generalCustomer"), address: " ", country: "Albania", town: " ", buyerIDType: "ID" }
                            : { tin: "", name: "", address: "", country: "Albania", town: "", buyerIDType: null },
                        },
                      }));
                    }}
                  />
                  <label htmlFor="noCustomerBar" className="custom-control-label">{t("invoice.noCustomer")}</label>
                </div>
              )}
              <button className="pos-command-bar__customer-btn" onClick={() => setCustomerDialogVisible(true)}>
                <FontAwesomeIcon icon={faUser} className="pos-command-bar__customer-icon" />
                <span>{posState?.parties?.buyer?.name || t("navbar.customers")}</span>
                {posState?.einvoice && <span className="pos-command-bar__einv-badge">E-INV</span>}
              </button>
              <button
                className="pos-command-bar__profile-btn"
                onClick={() => setProfileDialogVisible(true)}
                title="Profile"
              >
                {t("pos.profileId")} - P1
              </button>
              <div className="pos-command-bar__currency">
                <FontAwesomeIcon icon={faCoins} className="pos-command-bar__currency-icon" />
                <Select
                  styles={currencySelectStyle}
                  options={currenciesPos}
                  value={currenciesPos.find((c) => c.value === persistedData?.currency)}
                  onChange={(option) => {
                    setPersistedData({ ...persistedData, currency: option.value, rate: "1" });
                    handleChange("currency", option.value);
                    handleChange("rate", "1");
                    setIsUsingBoaRate(false);
                    setBoaExchangeRate(null);
                    setRateBoaDate(null);
                  }}
                  isSearchable={false}
                  menuPortalTarget={document.body}
                  className="pos-command-bar__currency-select"
                />
                {persistedData?.currency !== "ALL" && (
                  <>
                    <input
                      type="number"
                      className={`pos-command-bar__rate-input ${!isUsingBoaRate && boaExchangeRate && posState?.rate ? "pos-rate-warning" : ""}`}
                      value={posState?.rate}
                      step="0.01"
                      min="0"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (func.countDecimals(value) > 6) return;
                        setIsUsingBoaRate(false);
                        setPersistedData({ ...persistedData, rate: value });
                        handleChange("rate", value);
                      }}
                    />
                    <button className="pos-command-bar__boa-btn" onClick={getExchangeRates}>
                      GET BOA
                    </button>
                    {isUsingBoaRate && isRateBoaDateDifferent() && (
                      <>
                        <Tooltip target=".pos-rate-date-info" position="bottom" />
                        <span
                          className="pos-rate-date-info"
                          data-pr-tooltip={`${t("common.lastUpdate")}: ${rateBoaDate}`}
                          style={{ color: "#28a745", fontSize: "0.7rem", cursor: "help" }}
                        >
                          {rateBoaDate?.split(" ")[0]}
                        </span>
                      </>
                    )}
                    {!isUsingBoaRate && posState?.rate && boaExchangeRate && (() => {
                      const rateDiff = calculateRateDifference();
                      if (!rateDiff) return null;
                      const msg = t("invoice.customExchangeRateWithDiff", {
                        percentage: rateDiff.percentage,
                        direction: t(`invoice.${rateDiff.direction}`)
                      });
                      return (
                        <>
                          <Tooltip target=".pos-rate-warn-icon" position="bottom" />
                          <span
                            className="pos-rate-warn-icon"
                            data-pr-tooltip={msg}
                            style={{ color: "#ffc107", fontSize: "0.75rem", cursor: "help" }}
                          >
                            <FontAwesomeIcon icon={faTriangleExclamation} />
                            <span style={{ marginLeft: 3, fontSize: "0.65rem", fontWeight: 600 }}>
                              {rateDiff.percentage}%
                            </span>
                          </span>
                        </>
                      );
                    })()}
                  </>
                )}
              </div>
              <button
                className="pos-command-bar__fullscreen-btn"
                onClick={() => {
                  setIsFullScreen((fs) => {
                    if (!fs) setSideBarExpanded({ show: false, hover: false });
                    return !fs;
                  });
                }}
                title={isFullScreen ? "Exit Fullscreen" : "Fullscreen"}
              >
                <FontAwesomeIcon icon={isFullScreen ? faCompress : faExpand} />
              </button>
            </div>
            {/* Row 2: Search, Scan */}
            <div className="pos-command-bar__row2">
              <input
                id="inputID"
                type="text"
                className="pos-command-bar__search"
                placeholder={t("pos.item") + "..."}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <input
                type="text"
                id="code"
                name="code"
                ref={codeRef}
                className="pos-command-bar__scan"
                placeholder={t("item.scanCode")}
                value={code}
                onChange={(e) => setCode(e.target.value)}
              />
            </div>
          </div>

          {/* Categories Sidebar + Items Grid */}
          {allItems !== null ? (
            <div className="pos-content-area">
              {/* Vertical Categories Sidebar */}
              <div
                className="pos-categories-sidebar"
                ref={categoryTabsRef}
                onMouseDown={handleCategoryMouseDown}
                onMouseMove={handleCategoryMouseMove}
                onMouseUp={handleCategoryMouseUp}
                onMouseLeave={handleCategoryMouseUp}
              >
                <button
                  className={classnames("pos-category-item", { active: activeCategory === null })}
                  onClick={() => handleCategoryChange(null)}
                >
                  <span className="pos-category-item__name">{t("common.all") || "All"}</span>
                  <span className="pos-category-item__count">{allItems.length}</span>
                </button>
                {Object.entries(categories).map(([category, count], index) => (
                  <button
                    key={index}
                    className={classnames("pos-category-item", { active: activeCategory === category })}
                    onClick={() => handleCategoryChange(category)}
                  >
                    <span className="pos-category-item__name">{category}</span>
                    <span className="pos-category-item__count">{count}</span>
                  </button>
                ))}
              </div>

              {/* Items Grid with Quantity Badges */}
              <div className="pos-items-grid">
                {filteredItems.map((item) => {
                  let prices = priceByCurrency(item);
                  const cartItem = posState.items.find((ci) => ci.code === item.code);
                  return (
                    <div
                      key={item.id}
                      className="pos-item-card"
                      onClick={() => addRemoveItem(item)}
                    >
                      {cartItem && (
                        <span key={cartItem.quantity} className="pos-item-card__qty-badge">
                          {cartItem.quantity}
                        </span>
                      )}
                      <div className="pos-item-card__name">{item.name}</div>
                      <div className="pos-item-card__price">
                        {prices.priceWvat} {prices.currency}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Loader />
            </div>
          )}
        </div>

      </div>

      {/* Mobile Cart Backdrop */}
      <div
        className={classnames("pos-cart-backdrop", { "pos-cart-backdrop--visible": mobileCartOpen })}
        onClick={() => setMobileCartOpen(false)}
      />

      {/* ── RIGHT: Dark Cart Sidebar ── */}
      <div ref={cartPanelRef} className={classnames("pos-cart-sidebar", { "pos-cart-sidebar--open": mobileCartOpen })}>
          {/* Mobile Drawer Handle */}
          <div
            className="pos-cart-drawer-handle"
            onClick={() => setMobileCartOpen(prev => !prev)}
            onTouchStart={handleDrawerTouchStart}
            onTouchMove={handleDrawerTouchMove}
            onTouchEnd={handleDrawerTouchEnd}
          >
            <div className="pos-cart-drawer-handle__bar" />
          </div>

          {/* Dark Cart Header */}
          <div
            className="pos-cart-sidebar__header"
            onClick={() => setMobileCartOpen(prev => !prev)}
            onTouchStart={handleDrawerTouchStart}
            onTouchMove={handleDrawerTouchMove}
            onTouchEnd={handleDrawerTouchEnd}
          >
            <div className="pos-cart-sidebar__header-top">
              <div className="pos-cart-sidebar__title">
                <FontAwesomeIcon icon={faCartShopping} />
                {t("pos.order") || "Order"}
                {posState.items.length > 0 && (
                  <span className="pos-cart-sidebar__badge">{posState.items.length}</span>
                )}
              </div>
              <div className="pos-cart-header-total">
                {func.getFormattedMoneyValue(posState.invoiceTotalWithVat)} {persistedData.currency}
              </div>
              <div className={classnames("pos-cart-toggle-icon", { "pos-cart-toggle-icon--open": mobileCartOpen })}>
                <FontAwesomeIcon icon={faChevronUp} />
              </div>
            </div>
            <div className="pos-cart-sidebar__ops" onClick={(e) => e.stopPropagation()}>
              <button className="pos-op-btn pos-op-btn--initial" onClick={() => setCashRegisterTcrType({ actionType: "INITIAL", isOpen: true })}>
                <FontAwesomeIcon icon={faCashRegister} /> {t("pos.initial")}
              </button>
              <button className="pos-op-btn pos-op-btn--deposit" onClick={() => setCashRegisterTcrType({ actionType: "DEPOSIT", isOpen: true })}>
                <FontAwesomeIcon icon={faCashRegister} /> {t("pos.deposit")}
              </button>
              <button className="pos-op-btn pos-op-btn--withdraw" onClick={() => setCashRegisterTcrType({ actionType: "WITHDRAW", isOpen: true })}>
                <FontAwesomeIcon icon={faCashRegister} /> {t("pos.withdraw")}
              </button>
            </div>
          </div>

          {/* Info Strip */}
          <div className="pos-cart-sidebar__info">
            <div className="pos-cart-sidebar__info-item">
              <span>OP:</span>
              <span>{posState?.opCode}</span>
            </div>
            <div className="pos-cart-sidebar__info-item">
              <span>TCR:</span>
              <span>{posState?.tcrCode}</span>
            </div>
            <div className="pos-cart-sidebar__info-item">
              <span>{t("home.branches")}:</span>
              <span>{posState?.businessUnitCode}</span>
            </div>
          </div>

          {/* Cart Items List — only in review step */}
          {cartStep === "review" && (
            <>
              <div className="pos-cart-sidebar__items">
                {posState.items.length > 0 ? (
                  posState.items.map((item, index) => (
                    <div key={item.id || index} className="pos-cart-line">
                      <div className="pos-cart-line__index">{index + 1}</div>
                      <div className="pos-cart-line__body">
                        {/* Row 1: Name + Unit Price + Remove */}
                        <div className="pos-cart-line__header">
                          <div className="pos-cart-line__name">{item.name}</div>
                          <div className="pos-cart-line__unit-price">
                            {!zeroPriceItems[item?.code] ? (
                              <span>{item.quantity} x {func.formatNumber(item.priceWithVat)} {persistedData.currency}</span>
                            ) : (
                              <span>
                                {item.quantity} x{" "}
                                <input
                                  type="number"
                                  min="0.01"
                                  className="pos-price-input"
                                  placeholder="0.00"
                                  autoFocus
                                  value={item.priceWithVat}
                                  onChange={(e) => handlePriceWithVatChange(e, item, index)}
                                />
                                {" "}{persistedData.currency}
                              </span>
                            )}
                          </div>
                          <button className="pos-cart-line__remove" onClick={() => addRemoveItem(item, 0)}>
                            <FontAwesomeIcon icon={faTimesCircle} />
                          </button>
                        </div>

                        {/* Row 2: Qty Controls | Discount | Total Price */}
                        <div className="pos-cart-line__controls">
                          <div className="pos-cart-line__qty">
                            <div className="pos-qty-group">
                              <button className="pos-qty-btn" onClick={() => addRemoveItem(item, -"1")}>-</button>
                              <input
                                type="number"
                                className="pos-qty-input"
                                value={item.quantity}
                                onChange={(e) => addRemoveItem(item, e.target.value, true)}
                              />
                              <button className="pos-qty-btn" onClick={() => addRemoveItem(item, "1")}>+</button>
                            </div>
                          </div>

                          <div className="pos-cart-line__discount">
                            <div className="pos-discount-group">
                              <input
                                type="number"
                                className="pos-discount-input"
                                value={item.newDiscount}
                                min={0}
                                placeholder="0"
                                onKeyDown={(e) => {
                                  if (e.key === '-' || e.key === 'e') e.preventDefault();
                                }}
                                onChange={(e) => handleDiscountChange("discountValue", e.target.value, index)}
                              />
                              <button
                                className="pos-discount-toggle"
                                onClick={() =>
                                  handleDiscountChange(
                                    "discountType",
                                    item.discountType === "Percentage" ? "Value" : "Percentage",
                                    index
                                  )
                                }
                              >
                                {item.discountType === "Percentage" ? "%" : persistedData.currency}
                              </button>
                            </div>
                          </div>

                          <div className="pos-cart-line__total">
                            <span className="pos-cart-line__price">
                              {func.formatNumber(item.totalWithVat)} {persistedData.currency}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="pos-cart-empty">
                    <FontAwesomeIcon icon={faCartShopping} />
                    <p>{t("pos.noItems") || "No items added yet"}</p>
                    <small>{t("pos.selectItemHint") || "Select items from the left panel"}</small>
                  </div>
                )}
              </div>

              {/* Totals */}
              <div className="pos-cart-sidebar__totals">
                <div className="pos-totals__row">
                  <span className="pos-totals__label">{t("invoice.totalNoVat")}</span>
                  <span className="pos-totals__value">
                    {func.getFormattedMoneyValue(posState?.invoiceTotalWithoutVat)} {persistedData.currency}
                  </span>
                </div>
                <div className="pos-totals__row">
                  <span className="pos-totals__label">{t("invoice.totalDiscount")}</span>
                  <span className="pos-totals__value">
                    {func.getFormattedMoneyValue(posState.invoiceTotalDiscount)} {persistedData.currency}
                  </span>
                </div>
                <div className="pos-totals__row">
                  <span className="pos-totals__label">{t("invoice.totalVat")}</span>
                  <span className="pos-totals__value">
                    {func.getFormattedMoneyValue(posState?.invoiceTotalVat)} {persistedData.currency}
                  </span>
                </div>
                {persistedData.currency !== "ALL" && (
                  <div className="pos-totals__row">
                    <span className="pos-totals__label">{t("invoice.totalPay")} (LEK)</span>
                    <span className="pos-totals__value">
                      {func.getFormattedMoneyValue(convertedValue)} LEK
                    </span>
                  </div>
                )}
                <div className="pos-totals__row pos-totals__row--grand">
                  <span className="pos-totals__label">{t("invoice.totalPay")} ({persistedData.currency})</span>
                  <span className="pos-totals__value">
                    {func.getFormattedMoneyValue(posState.invoiceTotalWithVat)} {persistedData.currency}
                  </span>
                </div>
              </div>
            </>
          )}

          {/* Step-based Cart Footer */}
          <div className="pos-cart-sidebar__footer">
            {cartStep === "review" && (
              <div className="pos-action-row">
                <button
                  className="pos-action-btn pos-action-btn--clear"
                  disabled={posState.items.length === 0}
                  onClick={() => {
                    setPosState((state) => ({
                      ...defaultPosState,
                      paymentMethodType: state.paymentMethodType,
                      parties: {
                        ...state.parties,
                        buyer: { ...state.parties.buyer },
                      },
                    }));
                    setCartStep("review");
                  }}
                >
                  <FontAwesomeIcon icon={faTimesCircle} /> {t("pos.clear")}
                </button>
                <button
                  className="pos-action-btn pos-action-btn--payment"
                  disabled={posState.items.length === 0}
                  onClick={() => setCartStep("payment")}
                >
                  {t("pos.payment")} <FontAwesomeIcon icon={faArrowLeft} style={{ transform: 'rotate(180deg)' }} />
                </button>
              </div>
            )}
            {cartStep === "payment" && (
              <div className="pos-payment-step">
                <div className="pos-payment-step__header">
                  <button className="pos-payment-step__back" onClick={() => setCartStep("review")}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                  </button>
                  <span className="pos-payment-step__title">{t("pos.selectPayment")}</span>
                  <span className="pos-payment-step__amount">
                    {func.getFormattedMoneyValue(posState.invoiceTotalWithVat)} {persistedData.currency}
                  </span>
                </div>

                {/* Order Recap */}
                <div className="pos-order-recap">
                  {posState.items.map((item, index) => (
                    <div key={item.code || index} className="pos-order-recap__item">
                      <span className="pos-order-recap__qty">{item.quantity}x</span>
                      <span className="pos-order-recap__name">{item.name}</span>
                      <span className="pos-order-recap__price">{func.formatNumber(item.totalWithVat)} {persistedData.currency}</span>
                    </div>
                  ))}
                  <div className="pos-order-recap__total">
                    <span>{t("pos.total")}</span>
                    <span>{func.getFormattedMoneyValue(posState.invoiceTotalWithVat)} {persistedData.currency}</span>
                  </div>
                </div>

                <div className="pos-pay-grid">
                  {![4].includes(user?.role?.id) && (<>
                  <button
                    className="pos-pay-tile pos-pay-tile--banknote"
                    disabled={paymentMethodType === "noncash"}
                    onClick={() => handlePaymentMean("10", "cash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faMoneyBillAlt} /></span>
                    <span className="pos-pay-tile__label">{t("pos.banknote")}</span>
                  </button>
                  <button
                    className="pos-pay-tile pos-pay-tile--card"
                    disabled={paymentMethodType === "noncash"}
                    onClick={() => handlePaymentMean("48", "cash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faCreditCard} /></span>
                    <span className="pos-pay-tile__label">{t("pos.bankCard")}</span>
                  </button>
                  <button
                    className="pos-pay-tile pos-pay-tile--transfer"
                    onClick={() => handlePaymentMean("31", "noncash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faMoneyBill} /></span>
                    <span className="pos-pay-tile__label">{typeOfPaymentMeansNonCash[0].btnLabel?.toUpperCase() || "TRANSFER"}</span>
                  </button>
                  <button
                    className="pos-pay-tile pos-pay-tile--account"
                    onClick={() => handlePaymentMean("42", "noncash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faCoins} /></span>
                    <span className="pos-pay-tile__label">{typeOfPaymentMeansNonCash[1].btnLabel?.toUpperCase() || "ACCOUNT"}</span>
                  </button>
                  <button
                    className="pos-pay-tile pos-pay-tile--other"
                    onClick={() => handlePaymentMean("ZZZ", "noncash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faBan} /></span>
                    <span className="pos-pay-tile__label">{typeOfPaymentMeansNonCash[2].btnLabel?.toUpperCase() || "OTHER"}</span>
                  </button>
                  </>)}
                  <button
                    className="pos-pay-tile pos-pay-tile--draft"
                    onClick={() => draftInvoice({ invoiceState: posState })}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faCircleCheck} /></span>
                    <span className="pos-pay-tile__label">{t("pos.saveDraft") || "SAVE DRAFT"}</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

      {/* Finalize Dialog */}
      <Dialog
        visible={finalizeDialogVisible}
        onHide={() => { setFinalizeDialogVisible(false); }}
        className="swal-pos"
        closable={false}
        modal
        breakpoints={{ '960px': '80vw', '641px': '95vw' }}
        style={{ width: '50vw' }}
      >
        {finalizeDialogState && (
          <FinalizeInvoice
            onClose={() => { setFinalizeDialogVisible(false); }}
            fullCompany={fullCompany}
            approveInvoice={approveInvoice}
            posState={{ ...posState, ...finalizeDialogState }}
          />
        )}
      </Dialog>
    </div>
  );
};

export default CreatePosTransaction;
